import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import ProfilePage from '@pages/profile/ui/PageProfile';

export const Route = createFileRoute('/_auth/_layout/profile')({
  component: ProfilePage,
});
